import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";
import { VariantLogsResponse } from "../interface";

export const getVariantLogs = async (
  productId: number
): Promise<VariantLogsResponse> => {
  try {
    const response = await apiRequest<VariantLogsResponse>(
      "get",
      `/variant-loggers/${productId}`
    );

    return response;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch variant logs");
  }
};
